export default {
  Title: 'Αρχική',

  Company: {
    Name       : 'Π.ΟΜ.ΕΝ.Σ.',
    Description: 'Πανελλήνια ΟΜοσπονδία ΕΝώσεων Στρατιωτικών'
  }
}
